import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "categories-suggestion" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "categories-suggestion_loading m-tag-list"
}

import {DI} from '@/brief-hub/config/DependencyInjection';
    import {FreelancerProfileService} from '@/brief-hub/deposit/freelancer/FreelancerProfileService';
    import debounce from 'lodash/debounce';
    import {FreelancerCategoryResource} from '@/common/api/api-raw-types';
    import {ref, inject, watch, computed, PropType} from 'vue';
    import {useMediaQuery} from '@malt/joy-entrypoint/src/vue/use';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyCategoriesSuggestion',
  props: {
        value: {type: String, default: ''},
        visibleResult: {type: Number, default: null},
        selectedCategory: {type: String},
        categories: {type: Array as PropType<FreelancerCategoryResource[]>, required: true},
    },
  emits: ['load', 'select'],
  setup(__props, { emit: __emit }) {

    const emit = __emit;
    const {matchMedia} = useMediaQuery();

    const freelancerProfileService = inject<FreelancerProfileService>(DI.freelancerProfileService);

    const props = __props;

    const loading = ref<boolean>(false);
    const isMobile = computed(() => matchMedia.value.max.Xs);

    const debounceSearch = debounce(search, 300);

    watch(() => props.value, refreshPrediction, {immediate: true});

    function refreshPrediction(): void {
        loading.value = true;
        debounceSearch();
    }

    async function search(): Promise<void> {
        const [categoryPredictions, error] = await freelancerProfileService!.retrieveCategoryPrediction(props.value);
        if (!error && categoryPredictions) {
            if (props.visibleResult) {
                emit('load', categoryPredictions.slice(0, props.visibleResult));
            } else {
                emit('load', categoryPredictions);
            }
        }
        loading.value = false;
    }

    function handleSelectCategory(event: CustomEvent) {
        emit('select', event);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_selectable_item = _resolveComponent("joy-selectable-item")!
  const _component_joy_selectable_item_group = _resolveComponent("joy-selectable-item-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_joy_selectable_item_group, {
            "full-width": !isMobile.value,
            onJoySelectableItemGroupChange: handleSelectCategory,
            onValueChange: handleSelectCategory
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (category) => {
                return (_openBlock(), _createBlock(_component_joy_selectable_item, {
                  id: category.categoryId,
                  key: category.categoryId,
                  value: category.categoryId,
                  checked: category.categoryId === __props.selectedCategory,
                  name: "categorySuggestion"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(category.label), 1)
                  ]),
                  _: 2
                }, 1032, ["id", "value", "checked"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["full-width"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (skeletonTag) => {
            return _createElementVNode("div", {
              key: skeletonTag,
              class: "m-tag m-tag_secondary"
            })
          }), 64))
        ]))
  ]))
}
}

})